import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TableService {

  searchFormValue = new Subject<any>();
  searchType = new Subject<any>();
  searchQueryGrid = new Subject<any>();
  isShowTable = new BehaviorSubject<any>(false);
  searchOptions = new Subject<any>();
  isShowAccessDialog = new BehaviorSubject<boolean>(false);
  isShowLoginDialog = new BehaviorSubject<boolean>(false);
  columns = new Subject<any>();
  isLoggedIn = new BehaviorSubject<boolean>(false);
  products_current_datasource = new BehaviorSubject<any[]>([]);
  detail_view_product = new BehaviorSubject<any>('');
  cols = new BehaviorSubject<any[]>([]);
  totalRecords = new BehaviorSubject<number>(0);
  detailViewTemplate = new BehaviorSubject<any>({});
  TableRowsCounts = new BehaviorSubject<number[]>([]);
  productDetailView = new BehaviorSubject<boolean>(false);
  secondaryTableDetails = new BehaviorSubject<{}>({});
  imagesBaseUrl = new BehaviorSubject<{}>({});
  appNamePrivelege = new BehaviorSubject<''>('');
  backToList = new BehaviorSubject<any>({});
  tableState = new BehaviorSubject<any>({
    pageNumber: 1,
    rows: 50
  });
  tableStateWithDataSearch = new BehaviorSubject<any>({
    searchData: false,
    pageNumber: 1,
    rows: 50
  });
  popupContent = new BehaviorSubject<any>({ showPopup: false });
  searchedWords = new BehaviorSubject<any>([]);
  displayPopup = new BehaviorSubject<boolean>(false);
  searchPayload = new BehaviorSubject<any>({});

  // New data added (2-1-24 3.15pm)
  showResult = new BehaviorSubject<any>(false)

  constructor() { }

  sendBackToList(data: any) {
    this.backToList.next(data);
  }

  getBackToList() {
    return this.backToList.asObservable();
  }

  sendFormData(data: any) {
    this.searchFormValue.next(data);
  }

  getFormData() {
    return this.searchFormValue.asObservable();
  }

  sendShowTable(data: any) {
    this.isShowTable.next(data);
  }

  getShowTable() {
    return this.isShowTable.asObservable();
  }

  sendSearchOptions(data: any) {
    this.searchOptions.next(data);
  }

  getSearchOptions() {
    return this.searchOptions.asObservable();
  }

  sendSearchType(data: any) {
    this.searchType.next(data);
  }

  getSearchType() {
    return this.searchType.asObservable();
  }

  sendShowAccessDialog(data: boolean) {
    this.isShowAccessDialog.next(data);
  }

  getShowAccessDialog() {
    return this.isShowAccessDialog.asObservable();
  }

  sendShowLoginDialog(data: boolean) {
    this.isShowLoginDialog.next(data);
  }

  getShowLoginDialog() {
    return this.isShowLoginDialog.asObservable();
  }

  sendColumns(data: any[]) {
    this.columns.next(data);
  }

  getColumns() {
    return this.columns.asObservable();
  }

  sendLoggedIn(data: boolean) {
    this.isLoggedIn.next(data);
  }

  getLoggedIn() {
    return this.isLoggedIn.asObservable();
  }

  sendProductCurrentDatasource(data: any[]) {
    this.products_current_datasource.next(data);
  }

  getProductCurrentDatasource() {
    return this.products_current_datasource.asObservable();
  }

  sendDetailViewProduct(data: any) {
    this.detail_view_product.next(data);
  }

  getDetailViewProduct() {
    return this.detail_view_product.asObservable();
  }

  sendCols(data: any[]) {
    console.log('Sending Cols Data:', data);
    this.cols.next(data);
  }

  getCols() {
    return this.cols.asObservable();
  }

  sendTotalRecords(data: number) {
    this.totalRecords.next(data);
  }

  getTotalRecords() {
    return this.totalRecords.asObservable();
  }

  sendDetailViewTemplate(data: number) {
    this.detailViewTemplate.next(data);
  }

  getDetailViewTemplate() {
    return this.detailViewTemplate.asObservable();
  }

  sendTableRowsCounts(data: number[]) {
    this.TableRowsCounts.next(data);
  }

  getTableRowsCounts() {
    return this.TableRowsCounts.asObservable();
  }

  sendProductDetailView(data: boolean) {
    this.productDetailView.next(data);
  }

  getProductDetailView() {
    return this.productDetailView.asObservable();
  }

  sendSecondaryTableDetails(data: any) {
    this.secondaryTableDetails.next(data);
  }

  getSecondaryTableDetails() {
    return this.secondaryTableDetails.asObservable();
  }

  sendImagesBaseUrl(data: {}) {
    this.imagesBaseUrl.next(data);
  }

  getImagesBaseUrl() {
    return this.imagesBaseUrl.asObservable();
  }

  sendAppNamePrivelege(data: any) {
    this.appNamePrivelege.next(data);
  }

  getAppNamePrivelege() {
    return this.appNamePrivelege.asObservable();
  }

  sendTableState(data: any) {
    this.tableState.next(data);
  }

  getTableState() {
    return this.tableState.asObservable();
  }

  sendTableStateWithDataSearch(data: any) {
    this.tableStateWithDataSearch.next(data);
  }

  getTableStateWithDataSearch() {
    return this.tableStateWithDataSearch.asObservable();
  }

  sendPopupContent(data: any) {
    this.popupContent.next(data);
  }

  getPopupContent() {
    return this.popupContent.asObservable();
  }

  sendSearchedWords(data: any) {
    this.searchedWords.next(data);
  }

  getSearchedWords() {
    return this.searchedWords.asObservable();
  }

  sendDisplayPopup(data: any) {
    this.displayPopup.next(data);
  }

  getDisplayPopup() {
    return this.displayPopup.asObservable();
  }

  // new
  sendSearchPayload(data: any) {
    console.log('send Search Data payload:', data);
    this.searchPayload.next(data);
  }

  getSearchPayload() {
    return this.searchPayload.asObservable();
  }
}
